export const MODE_BY_YEAR = 'by_year';
export const MODE_TIMELINE = 'timeline';
export const MODE_BY_DATE = 'by_date';

export const MODES = [
  {
    value: MODE_BY_YEAR,
    label: 'По годам',
    hint: 'Дата внутри года, отдельная линия на каждый год',
  },
  {
    value: MODE_TIMELINE,
    label: 'Общий срез',
    hint: 'Непрерывная шкала времени за все годы',
  },
  {
    value: MODE_BY_DATE,
    label: 'Общий по дате',
    hint: 'Все годы сложены в один календарный год',
  },
];

export const GRANULARITY_DAY = 'day';
export const GRANULARITY_WEEK = 'week';
export const GRANULARITY_MONTH = 'month';

export const GRANULARITIES = [
  { value: GRANULARITY_DAY, label: 'По дням' },
  { value: GRANULARITY_WEEK, label: 'По неделям' },
  { value: GRANULARITY_MONTH, label: 'По месяцам' },
];

export const METRICS = [
  { value: 'total', label: 'Всего заявок' },
  { value: 'approved', label: 'Одобренные' },
  { value: 'asp', label: 'АСП' },
  { value: 'repeat', label: 'Повторные регистрации' },
];

export const SPLITS = [
  { value: 'total', label: 'Все школы (сумма)' },
  { value: 'school', label: 'По школам' },
];

// Tailwind theme tokens first (tailwind.config.js), then fillers, so the chart
// belongs to the same visual system as the rest of the admin panel.
export const SERIES_COLORS = [
  '#2C59F8',
  '#F45B2B',
  '#6DD24A',
  '#e7483d',
  '#717C9E',
  '#9333EA',
  '#0EA5E9',
  '#CA8A04',
  '#DB2777',
  '#0D9488',
  '#7C3AED',
  '#65A30D',
];

// Above this many lines the chart stops being readable; we warn instead of
// silently drawing spaghetti.
export const SERIES_WARN_THRESHOLD = 12;

export const RU_MONTH_SHORT = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек',
];

export const RU_MONTH_GENITIVE = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const RU_MONTH_NOMINATIVE = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];
